var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"click-outside",style:(`background-color: ${_vm.getTranspHexColor(_vm.getColor('not-primary'), 0.4)};`),on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.$emit('click-outside')}}},[_c('div',{staticClass:"self-centered standard-dialog",style:(`
      ${_vm.border_radius?`border-radius: ${_vm.border_radius};`:''}
      ${_vm.width?`width: ${_vm.width};`:''}
      ${_vm.height?`height: ${_vm.height};`:''}
      ${_vm.padding?`padding: ${_vm.padding};`:''}
      background-color: ${_vm.getTranspHexColor(_vm.getColor('not-primary'), 0.8)};
      `)},[_c('div',{staticClass:"standard-dialog-content"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }